// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"267":"component---src-pages-cenah-js","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"267":"596682f5778becd047c7","532":"8036379ecccb2ab786b0","678":"e27d24abccff05d56aff","883":"a50ae20643fc2cccc8cc"}[chunkId] + ".js";
};